
import React, { useState } from 'react';

function Register({ onRegisterSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // 密码强度校验
  const checkPasswordStrength = (pwd) => {
    return pwd.length >= 6 && /[A-Z]/.test(pwd) && /[a-z]/.test(pwd) && /[0-9]/.test(pwd);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!checkPasswordStrength(password)) {
      setError('密码需至少6位，包含大小写字母和数字');
      return;
    }
    if (password !== confirmPassword) {
      setError('两次输入的密码不一致');
      return;
    }
    try {
      const res = await fetch('http://localhost:3001/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, name })
      });
      const data = await res.json();
      if (data.success) {
        setSuccess('注册成功，正在跳转登录...');
        setTimeout(() => {
          if (onRegisterSuccess) onRegisterSuccess();
        }, 1200);
        setUsername('');
        setPassword('');
        setConfirmPassword('');
        setName('');
      } else {
        setError(data.message || '注册失败');
      }
    } catch (err) {
      setError('服务器错误');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '100px auto', padding: 24, border: '1px solid #eee', borderRadius: 8 }}>
      <h2>用户注册</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            placeholder="用户名"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
            style={{ width: '100%', marginBottom: 12, padding: 8 }}
          />
        </div>
        <div>
          <input
            type="password"
            placeholder="密码（至少6位，含大小写字母和数字）"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            style={{ width: '100%', marginBottom: 12, padding: 8 }}
          />
        </div>
        <div>
          <input
            type="password"
            placeholder="重复密码"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
            style={{ width: '100%', marginBottom: 12, padding: 8 }}
          />
        </div>
        <div>
          <input
            type="text"
            placeholder="姓名（可选）"
            value={name}
            onChange={e => setName(e.target.value)}
            style={{ width: '100%', marginBottom: 12, padding: 8 }}
          />
        </div>
        {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
        {success && <div style={{ color: 'green', marginBottom: 12 }}>{success}</div>}
        <button type="submit" style={{ width: '100%', padding: 10 }}>注册</button>
      </form>
    </div>
  );
}

export default Register;
